export const ACTIVE_YEAR = 2022;
export const FESTIVAL_DAYS = "12.-14.8.";
export const SITE_TITLE = `Flow Festival ${FESTIVAL_DAYS}-${ACTIVE_YEAR}`;
export const SITE_TITLE_SUFFIX = ` | ${SITE_TITLE}`;
export const OVERLAY_TRANSITION_DURATION = 500;
export const COOKIE_POLICY_TOAST_TRANSITION_DURATION = 500;
export const MUSIC_PROGRAM_COMPLETED = true;
export const ART_PROGRAM_COMPLETED = true;
// export const MAIL_CHIMP_SUBSCRIBE_URL = 'https://flowfestival.us12.list-manage.com/subscribe/post?u=dfb0247c6994358ec42ae0622&amp;id=12b0fabb66';
export const MAIL_CHIMP_SUBSCRIBE_URL =
  "https://flowfestival.us12.list-manage.com/subscribe/post-json";

// Is art included in navigation and pages
export const ART_ENABLED = true;

// Is family included in navigation and pages
export const FAMILY_ENABLED = true;

// Is talks included in navigation and pages
export const TALKS_ENABLED = true;

// Is custom Program Navigation displayed instead of title
export const PROGRAM_PAGE_NAVIGATION_ENABLED = true;

// Is program included in navigation and pages
export const PROGRAM_ENABLED = true;

// Is custom Program Navigation displayed instead of title
export const SCHEDULE_ENABLED = true;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/utils/constants.js